'use client';
import Hooks from '@benzinga/hooks';
import { QuotesV3FieldsManager } from '@benzinga/quotes-v3-fields-manager';
import { SessionContext } from '@benzinga/session-context';
import React from 'react';

export const useScannerFilterableDefs = () => {
  const session = React.useContext(SessionContext);
  const [scannerDefs, setScannerDefs] = React.useState(() =>
    session.getManager(QuotesV3FieldsManager).getFilterableFields(),
  );

  React.useEffect(() => {
    session.getManager(QuotesV3FieldsManager);
  }, [session]);

  Hooks.useSubscriber(session.getManager(QuotesV3FieldsManager), event => {
    switch (event.type) {
      case 'quotes_fields:update':
        setScannerDefs(session.getManager(QuotesV3FieldsManager).getFilterableFields());
        break;
    }
  });

  return scannerDefs;
};
